import { AlertBox } from '@iwoca/orion';

export const RefreshReminder = () => {
  return (
    <AlertBox variant="connect">
      <p className="m-0 p-0">
        <span className="font-med">Don't forget &mdash;</span>
        We'll need to refresh your spending limit after 30 days. That means the
        amount you have to spend could change based on you and your business.
      </p>
    </AlertBox>
  );
};
